/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReminderListDto } from '../models/ReminderListDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ReminderService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * The current user's reminders. Pass category to scope the list (and its
     * counts) to one reminder family — the Support Tickets badge uses
     * `category=SupportTicket` so it counts only support reminders, leaving the rest on
     * the notification bell.
     * @param unreadOnly
     * @param skip
     * @param take
     * @param category
     * @returns ReminderListDto OK
     * @throws ApiError
     */
    public getApiReminderMy(
        unreadOnly: boolean = false,
        skip?: number,
        take: number = 20,
        category?: string,
    ): CancelablePromise<ReminderListDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Reminder/my',
            query: {
                'unreadOnly': unreadOnly,
                'skip': skip,
                'take': take,
                'category': category,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Unread reminder count for the current user, optionally scoped to a single
     * category (e.g. `SupportTicket` for the Support Tickets badge).
     * @param category
     * @returns number OK
     * @throws ApiError
     */
    public getApiReminderUnreadCount(
        category?: string,
    ): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Reminder/unreadCount',
            query: {
                'category': category,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param guid
     * @returns any OK
     * @throws ApiError
     */
    public patchApiReminderRead(
        guid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/Reminder/{guid}/read',
            path: {
                'guid': guid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public patchApiReminderReadAll(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/Reminder/readAll',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param guid
     * @returns any OK
     * @throws ApiError
     */
    public deleteApiReminder(
        guid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/Reminder/{guid}',
            path: {
                'guid': guid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
